import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';

// Application Components
import { ListadoTiposEstablecimientosComponent } from './lista-inscripcion-establecimientos/listado-tipos-establecimientos.component';
import { ListadoTiposPoderesComponent } from './lista-inscripcion-poderes/listado-tipos-poderes.component';
import { ListaProductosFarmaceuticosComponent } from './lista-productos-farmaceuticos/lista-productos-farmaceuticos.component';
import { ListaDispositivosComponent } from './lista-inscripcion-dispositivos/lista-dispositivos.component';
import { ListaQuimicosComponent } from './lista-productos-quimicos/lista-quimicos.component';
import { ListaProductosCosmeticosComponent } from './lista-productos-cosmeticos/lista-productos-cosmeticos.component';
import { ListaInscripcionContratosComponent } from './lista-inscripcion-contratos/lista-inscripcion-contratos.component';
import { PostRegistroEstablecimientosComponent } from './lista-inscripcion-establecimientos/post-registro/post-registro-establecimientos.component';
import { PostRegistroPoderesComponent } from './lista-inscripcion-poderes/post-registro/post-registro-poderes.component';
import { PostRegistroProductosComponent } from './lista-productos/post-registro/post-registro-productos.component';
import { ListaInscripcionPublicidadComponent } from './lista-inscripcion-publicidad/lista-inscripcion-publicidad.component';
import {ListadoLotesVacuna} from './lista-lotes-vacunas/lista-lotes-vacunas.component';
import { RecolecionDatosMercado } from './lista-datos-mercado/lista-datos-mercado.component';
import { ListaRegistroEstupefacientesComponent } from './lista-datos-estupefacientes/lista-datos-estupefacientes.component';
import { PostRegistroContratosComponent } from './lista-inscripcion-contratos/post-registro-contratos/post-registro-contratos.component';
import { ListaAnalisisLaboratoriosComponent } from './lista-analisis-laboratorio/listado-analisis-laboratorio.component';
import { EntidadesComponent } from './entidades/entidades.component';
import { ListadoAlimentosYBebidas } from './lista-alimentos-bebidas/lista-alimentos-bebidas.component';
import { ListaEntidadesComponent } from './lista-entidades/lista-entidades.component';
import { Veterinarios } from './lista-veterinarios/lista-veterinarios.component';

const routes: Routes = [
  {
    path: '',
    children: [
      {
        path: 'establecimientos',
        component: ListadoTiposEstablecimientosComponent,
      },
      {
        path: 'registro/:tipo/:area',
        component: PostRegistroProductosComponent,
      },
      {
        path: 'post-registro/establecimientos',
        component: PostRegistroEstablecimientosComponent,
      },
      {
        path: 'poderes',
        component: ListadoTiposPoderesComponent,
      },
      {
        path: 'post-registro/poderes',
        component: PostRegistroPoderesComponent,
      },
      {
        path: 'farmaceuticos',
        component: ListaProductosFarmaceuticosComponent,
      },
      {
        path: 'contratos',
        component: ListaInscripcionContratosComponent,
      },
      {
        path: 'post-registro/contratos',
        component: PostRegistroContratosComponent,
      },
      {
        path: 'post-registro/:tipo',
        component: PostRegistroProductosComponent,
      },
      {
        path: 'dispositivos',
        component: ListaDispositivosComponent,
      },
      {
        path: 'quimicos',
        component: ListaQuimicosComponent,
      },
      {
        path: 'cosmeticoshigienicos',
        component: ListaProductosCosmeticosComponent,
      },
      {
        path: 'publicidad',
        component: ListaInscripcionPublicidadComponent,
      },
      {
        path: 'vacunas',
        component: ListadoLotesVacuna,
      },
      {
        path: 'datosmercado',
        component: RecolecionDatosMercado,
      },
      {
        path: 'estupefacientes',
        component: ListaRegistroEstupefacientesComponent,
      },
      {
        path: 'laboratorios',
        component: ListaAnalisisLaboratoriosComponent,
      },
      {
        path: 'lista-entidades',
        component: ListaEntidadesComponent,
      },
      {
        path: 'entidades',
        component: EntidadesComponent,
      },
      {
        path: 'disam-mag',
        component: ListadoAlimentosYBebidas,
      },
      {
        path: 'veterinarios', 
        component: Veterinarios,
      }
    ],
  },
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule],
})
export class ListaRoutingModule {}
